import Icon from '@components/utils/Icon'

export function displayAddress({ streetAddress, city, state, postcode }: GroupAddressProps): string | null {
  if (!streetAddress && !city && !postcode && !state) {
    return null
  }

  const stateAndPostcode = [city, state, postcode].filter(Boolean).join(' ')
  const address = [streetAddress, stateAndPostcode].filter(Boolean).join(', ')

  return address
}

type GroupAddressProps = {
  streetAddress?: string | null
  city?: string | null
  postcode?: string | null
  state?: string | null
}

const GroupAddress = ({ streetAddress, city, state, postcode }: GroupAddressProps) => {
  const address = displayAddress({ streetAddress, city, postcode, state })

  if (!address) return null

  return (
    <p
      className="tw:m-0 tw:inline-flex tw:items-center tw:gap-1 tw:text-sm tw:text-gray-true-500"
      data-testid="group-address"
    >
      <Icon type="location" width={14} height={14} className="tw:shrink-0" />
      {address}
    </p>
  )
}

export default GroupAddress
